import { OCW_CONFIG } from './configs/ocw.config';
import { Environment } from './environment.types';

export const environment: Environment = {
  production: true,
  variant: OCW_CONFIG.variant,
  mocked: false,
  ...OCW_CONFIG.test,
};
